import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#d2e5e4] text-black py-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h2 className="text-2xl font-bold mb-4">Medimind AI Solutions</h2>
          <p className="text-sm">
            AI Solutions crafted to simplify hospital, diagnostic & pharmacy
            operations with intelligence and care.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:underline">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:underline">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/blog" className="hover:underline">
                Blog
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">
                Contact us
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Products</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/medops" className="hover:underline">
                MedOps
              </Link>
            </li>
            <li>
              <Link to="/pharmaconnect" className="hover:underline">
                Pharma Connect
              </Link>
            </li>
            <li>
              <Link to="/apiintegrationssection" className="hover:underline">
                API Integration
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
          <p className="text-sm mb-2">📞 9888268456</p>
          <a
            href="mailto:sales@medimind.in"
            className="text-sm mb-2 flex items-center gap-2 hover:underline"
          >
            ✉️ sales@medimind.in
          </a>

          <p className="text-sm mb-2">
            📍 49, Capital Pk Rd, Cyber Hills Colony,{" "}
            <span className="ml-5">Madhapur, Hyderabad, Telangana,</span> <br />{" "}
            <span className="ml-5">500081.</span>
          </p>
          <p className="flex items-center space-x-2 text-sm mb-2">
            <span>Follow Us On:</span>
            <a
              href="https://www.linkedin.com/company/medimind-ai-solutions/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/16GWVKNAiV/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/medimindaisolutions?igsh=eGtlYm5sMjVhMTcy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-600"
            >
              <FaInstagram />
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-gray-400 mt-10 pt-6 text-sm text-center">
        &copy; {new Date().getFullYear()} Medimind AI Solutions. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
